"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4257],{

/***/ 4257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

function ElevenLabsBadge() {
    return null;
}
/* harmony default export */ __webpack_exports__["default"] = (ElevenLabsBadge);


/***/ })

}]);